const AppID = "15"; //请求接口应用号

export default {
  AppID
};



// WEBPACK FOOTER //
// ./src/Api/global_variable.js